// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2o4TJ","colCheckbox":"styles_colCheckbox__3-kVF"};